<script setup lang="ts">
import { useAuthStore } from '~/stores/auth.store';
const authStore = useAuthStore();

const { $t } = useNuxtApp();
</script>

<template>
  <UserInterfaceGradientBackgroundHolster
    :show-banner="false"
    :full-page="false"
    container-classes="!h-[70vh]"
    diamond-classes="!block"
  >
    <template #component>
      <section
        class="max-w-[340px] w-full rounded-lg overflow-hidden text-base-priority"
      >
        <div class="text-center p-4 text-base-priority bg-base font-bold">
          <span>
            {{ $t('document-verification-needed-title') }}
          </span>
        </div>
        <div
          class="p-4 text-xs bg-primary"
          v-html="$t('document-verification-needed-body')"
        />
        <div class="p-4 bg-base flex justify-center items-center">
          <DesignSystemButton
            rounding="lg"
            class="w-full justify-center items-center"
            @click="authStore.setAccountModalPage('document-verification')"
          >
            {{ $t('go-to-document-verification') }}
          </DesignSystemButton>
        </div>
      </section>
    </template>
  </UserInterfaceGradientBackgroundHolster>
</template>

<style scoped lang="scss"></style>
